import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'dakosy-to-distribute-linescape',
  template: require('./dakosy-to-distribute-linescape.component.html'),
  styles: [require('./../blog.component.scss'), require('./dakosy-to-distribute-linescape.component.scss')]
})
export class DakosyToDistributeLinescapeComponent extends BlogPage {
  title = "DAKOSY to Distribute Linescape’s Sailing Schedules - Linescape";
  description = "Hamburg Port Community to provide its members with access to the global sailing schedules and vessel data from the world’s leading data provider.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/dakosy-to-distribute-linescape/dakosy-to-distribute-linescape.component.ts